import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LoginPage from "@/pages/LoginPage";
import LandingPage from "@/pages/LandingPage";
import HomePage from "@/pages/HomePage";
import GradesPage from "@/pages/GradesPage";
import SubjectsPage from "@/pages/SubjectsPage";
import LessonsPage from "@/pages/LessonsPage";
import LessonDetailPage from "@/pages/LessonDetailPage";
import ImageSolverPage from "@/pages/ImageSolverPage";
import FounderPage from "@/pages/FounderPage";
import SubscribePage from "@/pages/SubscribePage";
import FeedbackPage from "@/pages/FeedbackPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import SemesterPage from "@/pages/SemesterPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";
import AdminStudentProfile from "@/pages/AdminStudentProfile";
import OlympicsPage from "@/pages/OlympicsPage";
import TeacherPage from "@/pages/TeacherPage";
import PrincipalPage from "@/pages/PrincipalPage";
import DirectorPage from "@/pages/DirectorPage";
import MinisterPage from "@/pages/MinisterPage";

// Auth Context
import { AuthProvider, useAuth } from "@/context/AuthContext";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="spinner"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Landing Page */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/founder" element={<FounderPage />} />
      <Route path="/subscribe" element={<SubscribePage />} />
      <Route path="/feedback" element={<FeedbackPage />} />
      <Route path="/how-it-works" element={<HowItWorksPage />} />
      
      {/* Protected Routes */}
      <Route path="/home" element={
        <ProtectedRoute>
          <HomePage />
        </ProtectedRoute>
      } />
      <Route path="/grades" element={
        <ProtectedRoute>
          <GradesPage />
        </ProtectedRoute>
      } />
      <Route path="/grades/:gradeId" element={
        <ProtectedRoute>
          <SemesterPage />
        </ProtectedRoute>
      } />
      <Route path="/grades/:gradeId/semester/:semesterId/subjects" element={
        <ProtectedRoute>
          <SubjectsPage />
        </ProtectedRoute>
      } />
      <Route path="/subjects/:subjectId/lessons" element={
        <ProtectedRoute>
          <LessonsPage />
        </ProtectedRoute>
      } />
      <Route path="/lessons/:lessonId" element={
        <ProtectedRoute>
          <LessonDetailPage />
        </ProtectedRoute>
      } />
      <Route path="/solve-image" element={
        <ProtectedRoute>
          <ImageSolverPage />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <ProfilePage />
        </ProtectedRoute>
      } />
      <Route path="/admin" element={
        <ProtectedRoute>
          <AdminPage />
        </ProtectedRoute>
      } />
      <Route path="/admin/student-profile/:userId" element={
        <ProtectedRoute>
          <AdminStudentProfile />
        </ProtectedRoute>
      } />
      <Route path="/olympics/:subjectId" element={
        <ProtectedRoute>
          <OlympicsPage />
        </ProtectedRoute>
      } />
      <Route path="/teacher" element={
        <ProtectedRoute>
          <TeacherPage />
        </ProtectedRoute>
      } />
      <Route path="/principal" element={
        <ProtectedRoute>
          <PrincipalPage />
        </ProtectedRoute>
      } />
      <Route path="/director" element={
        <ProtectedRoute>
          <DirectorPage />
        </ProtectedRoute>
      } />
      <Route path="/minister" element={
        <ProtectedRoute>
          <MinisterPage />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
